var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-center-list',{attrs:{"type":"web-content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }